module.exports = __webpack_public_path__ + "img/82.2f791fcb.jpg";